export default __webpack_public_path__ + "static/media/name-account-back.46027e6a.png";